export const PRECOCITY = [
  {
    label: 'Très précoce',
    value: 'Très précoce'
  },
  {
    label: 'Précoce',
    value: 'Précoce'
  },
  {
    label: 'Demi-précoce',
    value: 'Demi-précoce'
  },
  {
    label: 'Demi-tardif',
    value: 'Demi-tardif'
  },
];

export const SOIL_TYPE = [
  {
    label: 'Profond',
    value: 'Profond'
  },
  {
    label: 'Intermédiaire',
    value: 'Intermédiaire'
  },
  {
    label: 'Superficiel',
    value: 'Superficiel'
  },
];

export const TYPE = [
  {
    label: 'Oléique',
    value: 'Oléique'
  },
  {
    label: 'Linoléique',
    value: 'Linoléique'
  },
];

export const FILTERS = {
  'Précocité maturité': {
    key: 'precocite-maturite',
    value: [
    'Très précoce',
    'Précoce',
    'Précoce à demi-précoce',
    'Demi-précoce',
    'Demi-précoce à demi tardif',
    ]
  },
  'Vigueur de départ': {
    key: 'vigueur-de-depart',
    value: ['Bonne', 'Très bonne', 'Régulière', 'Excellente']
  },
  'Indice de masse foliaire': {
    key: 'indice-de-masse-foliaire',
    value: ['Moyen', 'Assez fort', 'Fort']
  },
  'Résistance Mildiou': {
    key: 'resistance-mildiou',
    value: [
      'RM9+',
      'RM9',
      'RM8+',
      'RM8'
    ]
  },
  'Tolérance Verticillium': {
    key: 'tolerance-verticillium',
    value: ['Oui', 'Non']
  },
  'Tolérance Phomopsis': {
    key: 'tolerance-phomopsis',
    value: [
      'Très peu sensible',
      'Peu sensible',
      'Peu sensible à sensible'
    ]
  },
  "Comportement à l'orobanche": {
    key: "comportement-a-lorobanche",
    value : ['Oui', 'Non']
  },
  'Richesse huile': {
    key: 'richesse-huile',
    value: [
      'Faible',
      'Moyenne',
      'Élevée',
      'Excellente'
    ]
  },
  "VRTH": {
    key: "vrth",
    value : ['Oui', 'Non']
  },
};
